import { useRef } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ReadingOverlay = () => (
  <div className="absolute inset-0 z-10 grid place-items-center rounded-xl bg-white/80 backdrop-blur-sm" data-testid="ai-reading">
    <div className="text-center">
      <Loader2 className="w-8 h-8 mx-auto animate-spin text-[#002FA7]" />
      <div className="mt-3 font-semibold">Reading ratecon…</div>
      <div className="text-xs text-slate-500 mt-1">This usually takes 10–30 seconds.</div>
    </div>
  </div>
);

export const RateconAutofill = ({ onFile, busy, fileName }) => {
  const ref = useRef(null);
  return (
    <div className="rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50 to-white p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="ratecon-autofill">
      <div className="w-11 h-11 rounded-xl bg-[#002FA7] text-white grid place-items-center shrink-0"><Sparkles className="w-5 h-5" /></div>
      <div className="flex-1">
        <div className="font-semibold" style={{ fontFamily: "Outfit" }}>Start with the ratecon</div>
        <p className="text-sm text-slate-600">Upload the PDF or a photo and AI fills in the load details for you to check.</p>
        {fileName && <p className="text-xs text-slate-500 mt-1 truncate">Using: {fileName}</p>}
      </div>
      <input
        ref={ref}
        type="file"
        accept="application/pdf,image/*"
        className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onFile(f); }}
        data-testid="ratecon-autofill-input"
      />
      <Button type="button" onClick={() => ref.current?.click()} disabled={busy} className="bg-[#002FA7] hover:bg-[#001A75] rounded-full" data-testid="ratecon-autofill-btn">
        {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1.5" />}
        {busy ? "Reading…" : fileName ? "Use a different ratecon" : "Upload ratecon to auto-fill"}
      </Button>
    </div>
  );
};
